"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck, Phone, ArrowRight, Star } from "lucide-react";
export default function HomeInsuranceCta() {
  const stars = Array.from({
    length: 5
  });
  return <section data-section-id="245881" id="call-to-action-section" className="relative w-full bg-background py-16 md:py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)/0.05_0%,transparent_60%)] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto bg-card border border-border rounded-3xl shadow-xl p-8 md:p-12 lg:p-16 text-center flex flex-col items-center space-y-8">
          
          <Badge variant="outline" className="bg-background px-4 py-1.5 text-sm border-primary/30 text-foreground shadow-sm">
            <ShieldCheck className="w-4 h-4 mr-2 text-primary" />
            Certified Florida Inspectors
          </Badge>

          <div className="space-y-4 max-w-2xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground tracking-tight">
              Ready to Secure Your Home?
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-default">
              Trusted Inspections is South Florida's choice for accurate 4-point inspections. We provide the detailed reporting your insurance carrier requires with the speed you deserve.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto pt-4">
            <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-base rounded-full bg-primary text-primary-foreground hover:bg-primary/90" asChild>
              <Link to="/FourPointInspectionSouthFloridaPage">
                Request a 4-Point Inspection
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="w-full sm:w-auto h-14 px-8 text-base rounded-full bg-background hover:bg-accent hover:text-foreground border-border" asChild>
              <Link to="tel:786-382-6895">
                <Phone className="mr-2 w-5 h-5 text-primary" />
                Call 786-382-6895
              </Link>
            </Button>
          </div>

          <div className="pt-8 mt-4 border-t border-border w-full max-w-md flex flex-col items-center gap-3">
            <div className="flex items-center gap-1 text-primary">
              {stars.map((_, i) => <Star key={i} data-index={i} className="w-5 h-5 fill-current" />)}
            </div>
            <p className="text-sm text-muted-foreground font-medium font-default">
              The most trusted name for <span className="text-foreground font-bold">South Florida</span> property inspections
            </p>
          </div>

        </div>
      </div>
    </section>;
}